import { render } from "./OverviewStep.vue?vue&type=template&id=246b63ce&scoped=true"
import script from "./OverviewStep.vue?vue&type=script&lang=js"
export * from "./OverviewStep.vue?vue&type=script&lang=js"

import "./OverviewStep.vue?vue&type=style&index=0&id=246b63ce&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246b63ce"]])

export default __exports__